<template>
  <div class="a4">
    <!-- 관계법령의 의무사항 이행현황 -->
    <div style="margin-bottom: 40px;">
      <div style="display: flex; align-items: center; margin-bottom: 14px;">
        <div class="bullseye none-colon" style="width: 354px; text-align-last: justify;">관계법령의 의무사항 이행현황</div>
        <span class="text-hint" style="margin-left: 10px; font-size: 22px;">※ 안전점검 기재 제외</span>
      </div>
      <div>
        <table class="double-border-header" style="border-width: 2px 0 2px 0; border-style: solid; border-color: #757575;">
          <colgroup>
            <col width="574px"/>
            <col width="150px"/>
            <col width="302px"/>
          </colgroup>
          <thead>
          <tr class="border-center" style="border-bottom: 6px double #757575;">
            <th style="border-right: 1px solid #757575;"><div style="padding: 5px 10px; text-align: center; ">의무사항</div></th>
            <th style="border-right: 1px solid #757575;"><div style="padding: 5px 10px; text-align: center;">이행여부</div></th>
            <th><div style="padding: 5px 10px; text-align: center;">개선계획</div></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="data in value.관계법령의의무사항이행현황"  class="border-center" style="border-bottom: 1px solid #757575; text-align: center;">
            <td><div style="padding: 15px 10px; border-right: 1px solid #757575;">{{ data.cell1 || "-"}}</div></td>
            <td><div style="padding: 15px 10px; border-right: 1px solid #757575;">{{ data.cell2 || "-"}}</div></td>
            <td><div style="padding: 15px 10px;">{{ data.cell3 || "-"}}</div></td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- 교육 이수현황 -->
    <div style="margin-bottom: 80px;">
      <div style="display: grid; margin-bottom: 14px;">
        <div class="bullseye none-colon" style="width: 180px; text-align-last: justify;">교육 이수현황</div>
        <span style="margin-left: auto; font-size: 20px;">[단위: 명]</span>
      </div>
      <div>
        <table class="double-border-header" style="border-width: 2px 0 2px 0; border-style: solid; border-color: #757575;">
          <colgroup>
            <col width="336px"/>
            <col width="150px"/>
            <col width="150px"/>
            <col width="240px"/>
            <col width="150px"/>
          </colgroup>
          <thead>
          <tr class="border-center" style="border-bottom: 1px solid #757575;">
            <th rowspan="2" style="border-right: 1px solid #757575;"><div style="padding: 5px 10px; text-align: center;">교육대상</div></th>
            <th rowspan="2" style="border-right: 1px solid #757575;"><div style="padding: 5px 10px; text-align: center; ">이수</div></th>
            <th colspan="2" style="border-right: 1px solid #757575;"><div style="padding: 5px 10px; text-align: center; ">미이수</div></th>
            <th rowspan="2"><div style="padding: 5px 10px; text-align: center;">비고</div></th>
          </tr>
          <tr style="border-bottom: 6px double #757575;">
            <th style="border-right: 1px solid #757575;"><div style="padding: 5px 10px; text-align: center;">이수계획</div></th>
            <th style="border-right: 1px solid #757575;"><div style="padding: 5px 10px; text-align: center;">사유</div></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="data in value.교육이수현황" class="border-center" style="border-bottom: 1px solid #757575; text-align: center;">
            <td><div style="padding: 5px 10px; border-right: 1px solid #757575;">{{ data.target || "-"}}</div></td>
            <td><div style="padding: 5px 10px; border-right: 1px solid #757575;">{{ (data.take === '이수' && data.plan) || '-' }}</div></td>
            <td><div style="padding: 5px 10px; border-right: 1px solid #757575;">{{ (data.take === '미이수' && data.plan) || '-'}}</div></td>
            <td><div style="padding: 5px 10px; border-right: 1px solid #757575;">{{ data.reason || "-"}}</div></td>
            <td><div style="padding: 5px 10px; ">{{ data.note || "-"}}</div></td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>


    <!-- ③ 관리개선 및 보완사항 -->
    <h3 style="background-color: #2B2D63; padding: 10px 16px; margin-bottom: 26px">③ 관리개선 및 보완사항</h3>

    <!-- 의무사항 미이행 현황 -->
    <div style="margin-bottom: 40px;">
      <div style="display: flex; align-items: center; margin-bottom: 14px;">
        <div class="bullseye none-colon" style="width: 270px; text-align-last: justify;">의무사항 미이행 현황</div>
      </div>
      <div>
        <table class="double-border-header" style="border-width: 2px 0 2px 0; border-style: solid; border-color: #757575;">
          <colgroup>
            <col width="213px"/>
            <col width="213px"/>
            <col width="300px"/>
            <col width="300px"/>
          </colgroup>
          <thead>
          <tr class="border-center" style="border-bottom: 6px double #757575;">
            <th style="border-right: 1px solid #757575;"><div style="padding: 5px 10px; text-align: center; ">관계법령</div></th>
            <th style="border-right: 1px solid #757575;"><div style="padding: 5px 10px; text-align: center; ">의무사항</div></th>
            <th style="border-right: 1px solid #757575;"><div style="padding: 5px 10px; text-align: center; ">미조치 사유</div></th>
            <th><div style="padding: 5px 10px; text-align: center; ">이행계획</div></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="data in value.의무사항미이행현황" class="border-center" style="border-bottom: 1px solid #757575; text-align: center;">
            <td><div style="padding: 15px 10px; border-right: 1px solid #757575;">{{ data.cell1 || "-"}}</div></td>
            <td><div style="padding: 15px 10px; border-right: 1px solid #757575;">{{ data.cell2 || "-"}}</div></td>
            <td><div style="padding: 15px 10px; border-right: 1px solid #757575;">{{ data.cell3 || "-"}}</div></td>
            <td><div style="padding: 15px 10px;">{{ data.cell4 || "-"}}</div></td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import PrintRadio from "@/components/print/PrintRadio.vue";
import Template from "@/views/boards/single-page/1044/print/Template.vue";

export default {
  components: {Template, PrintRadio},
  props: {
    header: Object,
    board: Object,
    value: Object,
  },
  computed: {
  },
  methods: {
  }
}
</script>
